<template>
  <div class="tw-grid tw-mb-4">
    <div class="tw-flex tw-items-start">
      <div class="tw-pt-0.5 tw-flex tw-items-center tw-whitespace-nowrap tw-text-infinity-secondary-text tw-mr-5 tw-font-medium tw-text-base tw-cursor-pointer" @click="filterOpen = !filterOpen">
        <span>Filter</span>
        <font-awesome-icon class="tw-ml-1.5" size="xs" :icon="['fas', 'chevron-up']" :flip="filterOpen ? 'vertical' : null"/>
      </div>
      <SoundkitsFilterChips />
    </div>
    <base-transition-expand>
      <div v-show="filterOpen">
        <SoundkitsFilterControls class="tw-mt-4" />
      </div>
    </base-transition-expand>
  </div>
</template>
<script>
import SoundkitsFilterChips from "./soundkits-filter-chips";
import SoundkitsFilterControls from "./soundkits-filter-controls";
import { defineComponent, reactive, ref, watch } from "@vue/composition-api";
import { provideSoundkitsFilterContext } from "./soundkits-filter";
export default defineComponent( {
  components: { SoundkitsFilterControls, SoundkitsFilterChips },
  setup(_, { emit }) {
    const filterOpen = ref(false)
    const state = reactive({
      selected: {
        types: null,
        tags: null,
        instruments: null,
        added: null,
        sortBy: null,
      }
    })

    provideSoundkitsFilterContext(state)

    /* On Filter Change */
    watch(() => state.selected, (filter) => {
      emit('filter-change', filter)
    }, {
      deep: true
    })

    return {
      filterOpen
    }
  }
});
</script>
